<template>
    <v-app>
        <div class="graph-scope-model-tooltip"><p></p></div>
        <tob-bar-alert></tob-bar-alert>
        <div class="app-version">v{{ appVersion }}</div>
        <v-app-bar v-if="$store.getters.userIsAuthenticated"  app color="#424242" class="main-toolbar">
            <v-btn
                :style="{visibility: canGoBack ? 'visible' : 'hidden'}"
                icon
                @click="goBack"
            >
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <router-link :to="{name: 'application-list'}"><svg width="35px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140">
                <path fill="url(#paint0_linear_696:2716)" d="M86.41 99.152c-.912.505-1.847.929-2.796 1.275a19.588 19.588 0 01-19.31-3.43 8.372 8.372 0 00-3.056-1.863 8.44 8.44 0 00-6.52.435 8.37 8.37 0 00-2.466 1.882 8.362 8.362 0 00.746 11.938l-.008.008c11.198 9.771 27.776 12.036 41.556 4.408 17.55-9.716 23.884-31.787 14.148-49.3-5.477-9.85-14.871-16.159-25.167-18.065a36.333 36.333 0 00-14.133.172A36.382 36.382 0 0059.3 50.389c-.938.607-1.914.932-2.526 1.547a8.368 8.368 0 00-1.57 10.344 8.399 8.399 0 007.55 4.186 8.366 8.366 0 004.841-1.506 19.506 19.506 0 018.896-2.367c6.908-.036 13.623 3.592 17.21 10.046 4.12 7.41 2.89 16.339-2.418 22.355-1.38 1.565-2.723 2.941-4.872 4.158z"/>
                <path fill="url(#paint1_linear_696:2716)" d="M52.742 40a19.716 19.716 0 012.796-1.276 19.588 19.588 0 0115.012.68 19.498 19.498 0 014.298 2.75 8.373 8.373 0 003.055 1.863 8.44 8.44 0 006.52-.434A8.37 8.37 0 0086.89 41.7a8.362 8.362 0 00-.746-11.938l.008-.007c-11.198-9.772-27.776-12.037-41.556-4.408-17.55 9.715-23.884 31.787-14.148 49.299 5.477 9.85 14.871 16.16 25.167 18.066 4.62.855 9.422.824 14.133-.172a36.38 36.38 0 0010.105-3.777c.938-.608 1.914-.932 2.526-1.548a8.368 8.368 0 001.57-10.343 8.399 8.399 0 00-7.55-4.186 8.365 8.365 0 00-4.841 1.506 19.506 19.506 0 01-8.896 2.366c-6.908.036-13.623-3.592-17.211-10.045-4.12-7.41-2.89-16.34 2.418-22.355 1.381-1.565 2.724-2.942 4.873-4.159z"/>
                <defs>
                    <linearGradient id="paint0_linear_696:2716" x1="50.107" x2="123.03" y1="49.456" y2="64.925" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FFDA16"/>
                        <stop offset=".344" stop-color="#FFA216"/>
                        <stop offset=".688" stop-color="#F5378B"/>
                        <stop offset="1" stop-color="#D0005C"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_696:2716" x1="90.624" x2="10.377" y1="88.486" y2="72.445" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#ABE8FF"/>
                        <stop offset=".266" stop-color="#5AC6FF"/>
                        <stop offset="1" stop-color="#2D4294"/>
                    </linearGradient>
                </defs>
            </svg>
            </router-link>
            <v-app-bar-title> {{ $store.getters.currentRouteVerbose($route) }} </v-app-bar-title>
            <v-spacer></v-spacer>
            <v-badge
                v-if="$store.state.api.modelsFlagLoaded.organizationData"
                class="running-instances-badge"
                v-model="maxRunningInstancesReached"
                color="#424242"
            >
                <template v-slot:badge>
                    <v-icon
                        dark
                        small
                        @click="openDialogMaxInstanceReached"
                    >info</v-icon>
                </template>
                <span v-if="!$store.getters.freeVersion">{{$t('app.running_instance',{running: runningInstances, allowed :allowedInstances })}}
                </span>
            </v-badge>
            <feedback
                :name="$t('app.feedback_name.alert')"
                :list="$store.getters.alerts"
                type="error"
                icon="warning"
            ></feedback>
            <feedback
                :name="$t('app.feedback_name.alarm')"
                :list="$store.getters.alarms"
                icon="notification_important"
            ></feedback>
            <el-switch
                :value="localeValue"
                active-color="#409EFF"
                inactive-color="#409EFF"
                active-text="FR"
                inactive-text="EN"
                active-value="fr"
                inactive-value="en"
                @change="changeLocale"
            >
            </el-switch>
            <v-btn
                dark
                icon
                @click="showLogoutConfirm"
            >
                <v-icon class="logout-btn">logout_outlined</v-icon>
            </v-btn>
            <dialog-confirm
                ref="modal-logout"
                :text="$t('app.dialog.text')"
                :title="$t('app.dialog.title')"
                :callback-confirm="logout"
                :text-confirm="$t('app.dialog.confirm')"
                :text-decline="$t('app.dialog.decline')"
                class="comfirm-dialog-logout"
            ></dialog-confirm>

        </v-app-bar>
        <v-main>
            <v-container fluid class="ma-6 pa-6">
                <login v-if="!$store.getters.userIsAuthenticated"></login>
                <loading v-else-if="!$store.getters.initialDataLoaded"></loading>
                <router-view v-else></router-view>
            </v-container>
            <v-snackbar
                v-model="display"
                :color="getSnackbarState.color"
                :right="true"
                :top="true"
            >
                <v-icon>{{ getSnackbarState.icon }}</v-icon> {{ getSnackbarState.text }}
            </v-snackbar>
        </v-main>
        <dialog-max-instance-reached
            ref="max-instance-reached"
            v-if="$store.state.api.modelsFlagLoaded.organizationData"
        ></dialog-max-instance-reached>
    </v-app>
</template>

<script>
import DialogConfirm from '@/components/Partials/dialog-confirm.vue';
import Login from './components/page/Login';
import Feedback from './components/partials/feedback-item.vue';
import Loading from './components/page/Loading';
import DialogMaxInstanceReached from '@/components/Partials/dialog-max-running-instance-reached';
import TobBarAlert from 'fundation-app-vuejs/src/components/layouts/dashboard/TopbarAlert.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    name: 'App',
    components: {
        Login,
        Feedback,
        Loading,
        DialogMaxInstanceReached,
        TobBarAlert,
        DialogConfirm,
    },

    data() {
        return {
            display: false,
            checkVersionHandler: null,

        };
    },

    computed: {
        ...mapGetters([
            'getSnackbarState',
            'displaySnackbar',
            'runningInstances',
            'allowedInstances',
            'maxRunningInstancesReached',
        ]),

        canGoBack (){
            return this.$route.name !== 'application-list';
        },

        appVersion (){
            return VERSION;
        },
        localeValue() {
            return this.$store.state.currentLocaleValue;
        }
    },

    watch: {
        displaySnackbar(val) {
            this.display = val;
        },
        display(val) {
            this.$store.commit('SET_DISPLAY_SNACKBAR', val);
        },
        '$store.getters.currentOrganisation': {
            handler  (val, oldVal) {
                if(!oldVal && val || (oldVal && val && oldVal.uid !== val.uid)){
                    this.$store.dispatch('setScope', {'X-Entity-Uid': val.uid});
                }
            },
            deep: true,
            immediate: true,
        },
        '$store.getters.userIsAuthenticated': {
            handler  (val) {
            // l'organisation est le model qui scope les autres, si on ne le fetch pas avant les autres on n'est pas sure de l'odre de retour des fetchs et donc le scope ne sera pas assigné avant de fetché les autres models
                if(val){
                    this.$store.dispatch('fetchModelByName', 'organizations').then(() => {
                        this.$store.dispatch('setScope', {'X-Entity-Uid': this.$store.getters.currentOrganisation.uid});

                    });
                }
            },
            immediate: true,
        },
    },

    created (){
    },

    mounted (){
        this.$nextTick(() => {
            window.addEventListener('resize', this.getWindowWidth);

            this.getWindowWidth();
        });
        this.checkVersion();
        this.$store.dispatch('loadModels').catch(() => {});
    },

    methods: {
        changeLocale(value) {
            this.$store.dispatch('changeCurrentLocale', value);
            // .then(() => {
            //     console.log('then')
            //     this.$i18n.locale = value;
            // });
            this.$i18n.locale = value;
        },
        goBack (){
            this.$router.go(-1);
        },

        getWindowWidth() {
            this.$store.commit('SET_WW', document.documentElement.clientWidth);
        },
        showLogoutConfirm(){
            this.$refs['modal-logout'].open();
        },
        logout() {
            this.$store.dispatch('logoutUser');
        },
        goToSettings() {
            this.$router.push('/settings');
        },
        openWebsite (){
            let win = window.open(`${this.$store.getters.managerUrl}`, '_blank');
            win.focus();
        },
        openDialogMaxInstanceReached (){
            this.$refs['max-instance-reached'].open();
        },
        checkVersion (){
            axios.get(this.$store.getters.appStatusUrl).then(result => {
                try {
                    if (result.data.version == this.appVersion) {
                        this.$store.dispatch('fundation/is_up_to_date');
                    } else {
                        this.$store.dispatch('fundation/need_update');
                    }
                } catch (e) {
                    console.error('Cannot check version, please ensure webpack build-tool is well configured');
                    this.$store.dispatch('fundation/is_up_to_date');
                }
            }).catch((error) => {
                if(error.response.status == 404){
                    this.$store.commit('fundation/DONT_RETRY_STATUS');
                }
                this.$store.dispatch('fundation/is_up_to_date');
            }).finally(() => {
                this.checkVersionHandler = setTimeout(() => {
                    this.checkVersion();
                }, 10000);
            });
        }
    },
};
</script>

<style lang="scss">
@import './main.scss';
.graph-scope-model-tooltip{
    position: absolute;
    visibility: hidden;
    background-color: rgb(255, 255, 255);
    border-radius: 2px;
    border: 1px solid rgb(202, 202, 202);
    color: rgb(0, 0, 0);
    font-size: 15px;
    padding: 20px;
    top: 94px;
    left: 51.7422px;
    z-index: 13;
}
html, body{
    margin: 0px;
    padding: 0px;
}
a:hover, a:focus{
    color: #82b1ff;
}

input::placeholder{
    ::-webkit-input-placeholder { opacity: 1; -webkit-transition: opacity .5s; transition: opacity .5s; }  /* Chrome 56, Safari 9 */
:-moz-placeholder { opacity: 1; -moz-transition: opacity .5s; transition: opacity .5s; } /* FF 4-18 */
::-moz-placeholder { opacity: 1; -moz-transition: opacity .5s; transition: opacity .5s; } /* FF 19-51 */
:-ms-input-placeholder { opacity: 1; -ms-transition: opacity .5s; transition: opacity .5s; } /* IE 10+ */
::placeholder { opacity: 1; transition: opacity .5s; }
}

input::focus{
    *:focus::-webkit-input-placeholder { opacity: 0; } /* Chrome 56, Safari 9 */
*:focus:-moz-placeholder { opacity: 0; } /* FF 4-18 */
*:focus::-moz-placeholder { opacity: 0; } /* FF 19-50 */
*:focus:-ms-input-placeholder { opacity: 0; } /* IE 10+ */
*:focus::placeholder { opacity: 0; } /* Modern Browsers */
}
.main-toolbar {
    z-index: 3;
    .comfirm-dialog-logout{
        margin-right: 25px !important;
    }
}
.running-instances-badge {
    margin-right: 15px;
    .v-badge__badge{
        height: 16px;
        width: 16px;
        right: -15px;
        span{
            line-height: 12px;
        }
    }
}
.app-version{
    position: absolute;
    bottom: 5px;
    right : 15px;
    z-index: 99999;
}
.alert-wrapper {
    transform: translate(0, -48px);
    transition: all 1s;
}
.logout-btn {
    width: 1rem !important;;
    display: inline !important;
}
.el-switch__label {
    color: white !important;
}
.el-switch__label.is-active {
    color: white !important;
    background-color: #409EFF !important;
    border-radius: 50px !important;
    width: 30px !important;
    height: 30px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.v-app-bar-title{
    &__content{
        width: initial !important;
    }
}

.v-window__container{
    height: 100vh !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue